module.exports = __webpack_public_path__ + "static/media/redArrow.3bbfef78.svg";